'use strict';

var React = require('react');
var timers = require('../../../helpers/timers.js');
var promise = require('../../../helpers/promise.js');

const parseBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    const listener = () => {
        const base64 = reader.result;
        typeof base64 === 'string' ? resolve(base64) : reject(new Error('base 64 value is not a string'));
        reader.removeEventListener('load', listener);
    };
    reader.addEventListener('load', listener);
    try {
        reader.readAsDataURL(file);
    }
    catch (error) {
        reader.removeEventListener('load', listener);
        reject(error);
    }
});
const useBase64Parser = ({ onError, onResult, successStateDurationInMs, minPendingStateDurationInMs, }) => {
    const [state, setState] = React.useState('idle');
    const abortableRef = React.useRef(null);
    const parseFile = React.useCallback((file) => {
        if (!onResult || !onError) {
            setState('success');
            return;
        }
        abortableRef.current?.abort();
        setState('pending');
        abortableRef.current = promise.makeAbortable({
            promise: Promise.all([parseBase64(file), timers.delay(minPendingStateDurationInMs)]),
            onFulfilled: ([base64]) => {
                onResult(file, base64);
                setState('success');
            },
            onRejected: error => onError(file, error),
        });
    }, [onResult, onError, minPendingStateDurationInMs]);
    React.useEffect(() => {
        if (state !== 'success') {
            return;
        }
        const timeout = globalThis.setTimeout(() => setState('idle'), successStateDurationInMs);
        return () => globalThis.clearTimeout(timeout);
    }, [state, successStateDurationInMs]);
    return [parseFile, state];
};

exports.useBase64Parser = useBase64Parser;
//# sourceMappingURL=useBase64Parser.js.map
